module.exports = __webpack_public_path__ + "media/images/user_icon2-b8192f308cf03c09c85405a7f50326e3.png";